  import popupStyles from "./../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import integrationStyles from "../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { Divider, Grid, Typography } from '@mui/material';

const IntegrationNotAvailablePopup = () => {
    
    return (
        <>
            <Grid item xs={12}>
                <Grid container direction="column" justifyContent="center">
                    <Grid item textAlign="center">
                        <Typography className={popupStyles.popupTitleTypography}>
                            Integration Limit Reached
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider className={popupStyles.popupTitleDivider} />
                    </Grid>

                    <Grid item>
                        <Grid container className={popupStyles.popupBodyGridContainer}>
                            <Typography className={integrationStyles.integrationNotAvailablePopupBodyTypography}>
                                You have reached the maximum number of integrations allowed on your current plan. Please <a href='/plans'>upgrade</a> to a higher plan to add more integrations.
                            </Typography>        
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default IntegrationNotAvailablePopup
